import { createAction } from '@reduxjs/toolkit'
import {
  OnboardingStage,
  SectionType,
  WorkforceSyncType,
  SectionStatus,
} from './onboardingSlice'

const updateOnboardingStage = createAction<OnboardingStage>(
  'onboarding/updateOnboardingStage'
)

const updateWorkforceSyncType = createAction<WorkforceSyncType>(
  'onboarding/updateWorkforceSyncType'
)

const updateOnboardingSectionStatus = createAction<{
  sectionType: SectionType
  status: SectionStatus
}>('onboarding/updateOnboardingSectionStatus')

const updateWelcomeModalShown = createAction<boolean>(
  'onboarding/updateWelcomeModalShown'
)

const updateIsEmployeeOnboarding = createAction<boolean>(
  'onboarding/updateIsEmployeeOnboarding'
)

const updateJustCompletedOnboarding = createAction<boolean>(
  'onboarding/updateJustCompletedOnboarding'
)

const createConnectedAccount = createAction<any>(
  'onboarding/createConnectedAccount'
)

export const onboardingActions = {
  updateOnboardingStage,
  updateWorkforceSyncType,
  updateOnboardingSectionStatus,
  updateWelcomeModalShown,
  updateIsEmployeeOnboarding,
  updateJustCompletedOnboarding,
  createConnectedAccount,
}
